import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import Circle from '../../../../../../packages/kiti/components/shapes/Circle'
import Text from '../../../../../../packages/kiti/components/presentation/Text'

const CounterTitle = ({ presentation, name, color, value, all }) => {
  const showPercentage = presentation === 'bar'

  return (
    <Grid gap={0.3} align="center">
      <Circle color={color || 'dark5'} size={1} />
      <Text size="p">{name}</Text>
      <Col flex={1} />

      {showPercentage && (
        <Text bold color="dark3" size="xsmall">
          {((value / all) * 100).toFixed(2)} %
        </Text>
      )}
    </Grid>
  )
}

export default CounterTitle
